const Percentage = ({ color, type }) => {
  const regular = (
    <svg
      width="17"
      height="15"
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.07951 3.88003C7.07951 5.13337 6.75951 6.09337 6.11951 6.76003C5.47951 7.42669 4.61951 7.76003 3.53951 7.76003C2.45951 7.76003 1.59951 7.42669 0.959512 6.76003C0.319512 6.09337 -0.000488281 5.13337 -0.000488281 3.88003C-0.000488281 2.62669 0.319512 1.6667 0.959512 1.00003C1.59951 0.333364 2.45951 3.05176e-05 3.53951 3.05176e-05C4.61951 3.05176e-05 5.47951 0.333364 6.11951 1.00003C6.75951 1.6667 7.07951 2.62669 7.07951 3.88003ZM4.81951 3.88003C4.81951 3.20003 4.69951 2.70669 4.45951 2.40003C4.21951 2.09337 3.91285 1.94003 3.53951 1.94003C3.15285 1.94003 2.83951 2.09337 2.59951 2.40003C2.37285 2.70669 2.25951 3.20003 2.25951 3.88003C2.25951 4.56003 2.37285 5.06003 2.59951 5.38003C2.83951 5.68669 3.15285 5.84003 3.53951 5.84003C3.91285 5.84003 4.21951 5.68669 4.45951 5.38003C4.69951 5.06003 4.81951 4.56003 4.81951 3.88003ZM10.9795 0.320032H13.7595L5.93951 14.18H3.15951L10.9795 0.320032ZM16.9595 10.62C16.9595 11.8734 16.6395 12.8334 15.9995 13.5C15.3595 14.1667 14.4995 14.5 13.4195 14.5C12.3395 14.5 11.4795 14.1667 10.8395 13.5C10.1995 12.8334 9.87951 11.8734 9.87951 10.62C9.87951 9.36669 10.1995 8.40669 10.8395 7.74003C11.4795 7.07337 12.3395 6.74003 13.4195 6.74003C14.4995 6.74003 15.3595 7.07337 15.9995 7.74003C16.6395 8.40669 16.9595 9.36669 16.9595 10.62ZM14.6995 10.62C14.6995 9.94003 14.5795 9.44669 14.3395 9.14003C14.0995 8.83337 13.7929 8.68003 13.4195 8.68003C13.0329 8.68003 12.7195 8.83337 12.4795 9.14003C12.2529 9.44669 12.1395 9.94003 12.1395 10.62C12.1395 11.3 12.2529 11.8 12.4795 12.12C12.7195 12.4267 13.0329 12.58 13.4195 12.58C13.7929 12.58 14.0995 12.4267 14.3395 12.12C14.5795 11.8 14.6995 11.3 14.6995 10.62Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Percentage;
